import jindalTyresImg from "../images/division_jindal_tyres.webp";
import rajeshImg from "../images/division_rajesh_automobiles.webp";
import petroworldImg from "../images/division_petroworld_servo.webp";
import namanImg from "../images/division_naman_enterprises.webp";
import minggoImg from "../images/division_minggo.webp";
import playzoneImg from "../images/division_playzone.webp";

const businessData = [
  {
    id: 1,
    title: "Ramkaran Rajeshkumar Jindal Tyres",
    image: jindalTyresImg,
    info: "Premium tyre dealership for all vehicles — 2-wheelers, cars, SUV, bus, truck, off-road, and tractor. Services include 3D wheel alignment, computerised balancing, automated tyre changing, tubeless puncture repair, nitrogen filling, and car pickup & drop facility. Authorised JK Tyre & Bridgestone dealer.",
    anchor: "#jindal-tyre",
    path: "/tyres",
  },
  {
    id: 2,
    title: "Rajesh Automobiles",
    image: rajeshImg,
    info: "Industrial petroleum product transporter for L.D.O., Furnace Oil, L.S.H.S., Fuel Oil, Pyrolysis Oil, and more across central India (Maharashtra, MP, Chhattisgarh, Gujarat). Nagpur's largest fleet owner with quality, quantity, and timely delivery — trusted for over 42 years.",
    contact: "M: 9970153000 / 8999181685 | Ph: 0712-2762798",
    path: "/rajesh-automobiles",
  },
  {
    id: 3,
    title: "Petroworld Servo",
    image: petroworldImg,
    info: "Indian Oil petrol pump offering Petrol, Diesel, XP95 (Xtra-premium 95 octane petrol), and Servo Lubricants. Services include oil changing facility, air filling, and nitrogen air.",
    contact: "M: 9373104846 | Ph: 0712-2769638",
    path: "/petroworld",
  },
  {
    id: 4,
    title: "Naman Enterprises",
    image: namanImg,
    info: "Trading in L.D.O., Furnace Oil, L.S.H.S., Fuel Oil, Pyrolysis Oil, and related industrial fuels. Dealing in company products (IOCL, HPCL, BPCL, Reliance, Nayara) and imported product — a trusted partner for over 15 years.",
    contact: "M: 9970153000 / 8999181685 | Ph: 0712-2762798",
    path: "/naman-enterprises",
  },
  {
    id: 5,
    title: "MinGGo — Infants • Toys • Gifts",
    image: minggoImg,
    info: "Visit for a wide range of children's items — infants, toys, school essentials, birthday supplies, games, gifting, and more. Best quality products at very reasonable rates. 10% OFF on MRP*. Sunday Open.",
    isButton: true,
    link: "https://www.minggo.in",
    anchor: "#minggo-store",
    path: "/minggo",
  },
  {
    id: 6,
    title: "MinGGo Playzone",
    image: playzoneImg,
    info: "Nagpur's ultimate indoor play area and party venue for kids. Featuring premium soft play structures, sliding zones, ball pools, interactive games, and custom birthday packages for a safe, hygienic, and fun-filled experience.",
    anchor: "#playzone-store",
    path: "/minggo-playzone",
  },
];

export default businessData;
